module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2f"
  }, [_c('a', {
    attrs: {
      "id": "pvii"
    }
  }), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagevii",
      "title": "vii"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("My father and I crofted in Smirisary at the same time as Margaret Leigh became a crofter in the 1940s. At that time there were four families working the land; they were hard but happy days. Many an hour I spent with Margaret, exchanging stories while herding cattle.")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Margaret Leigh was the only crofter in Smirisary with a horse. To the great amusement of the older folk it would not always do as she wanted it to. However, it was a great help to us all when peat had to be brought home.")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Margaret very quickly became part of the crofting community and was well thought of. It all seems such a long time ago!")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("I am 81 years old; I have seen many changes, not least of which is the end of the crofting community as I knew it.")]), _vm._v(" "), _c('div', {
    staticClass: "move"
  }, [_c('p', {
    staticClass: "parar"
  }, [_vm._v("Katy Maclean "), _c('em', [_vm._v("née")]), _vm._v(" Gillies")]), _vm._v(" "), _c('p', {
    staticClass: "parar"
  }, [_c('em', [_vm._v("Gortean")])]), _vm._v(" "), _c('p', {
    staticClass: "parar"
  }, [_c('em', [_vm._v("Smirisary")])]), _vm._v(" "), _c('p', {
    staticClass: "parar"
  }, [_c('em', [_vm._v("1996")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45dff8ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm01.vue
// module id = 69
// module chunks = 0